<script setup lang="ts">
import { useAuthStore } from '@stores/useAuthStore';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

interface Emits {
  (event: 'update:currentStep', step: number): void;
}

defineEmits<Emits>();

const { user } = useAuthStore();
</script>

<template>
  <h2 class="text-2xl">Welkom <span v-if="user">{{ user.first_name }}</span></h2>
  <p>
    Om onze samenwerking verder voort te zetten vragen we je hierbij om je online te identificeren en akkoord te gaan met de voorwaarden.
    Zijn beiden gedaan en akkoord, dan kun je gebruik maken van de vernieuwde Intermediairsportal.
  </p>
  <p>
    <strong>Dit neemt slechts een paar minuten van je tijd in beslag.</strong>
    Alvast bedankt voor je medewerking.
  </p>
  <UIButton
    data-test-id="start-intermediair-onboarding"
    class="w-full"
    @click="$emit('update:currentStep', user?.terms_and_conditions_accepted ? 3 : 2)"
  >
    Starten
    <template #icon-end>
      <FontAwesomeIcon :icon="['fas', 'arrow-right']" size="1x" />
    </template>
  </UIButton>
  <div class="bg-blue-50 rounded-xl p-6">
    <strong>Dit is verplicht en niet uit te stellen.</strong>
    Zonder de online identificatie en het akkoord op de voorwaarden,
    kunnen wij je helaas geen toegang geven tot het Intermediairsportal.
  </div>
</template>
